<template>
    <div
        class="row recent-orders submit-order-button pt-4"
        style="background-color: gainsboro; height: 100vh"
    >
        <div v-if="iframelink != null  && !success">
            <div class="col-md-12 pb-3">
                <h3>Document Signing</h3>
            </div>
            <iframe :src="this.iframelink" class="w-full"></iframe>
        </div>
        <div v-else-if="iframelink == null && !success">
            <div class="loadarea">
                <div class="spinner-border text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <div class="text-center w-100 mt-3">
                    <template v-if="!hasSigned">
                        Initializing Signing Session
                    </template>
                    <template v-else> Saving Document Data </template>
                </div>
            </div>
        </div>
        <div v-else-if="success">
            <div class="col-md-12 pt-4">
                <h1>
                    Document has been saved, you may now close this session.
                </h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["framelink", "documentkey"],
    emits: [],
    setup() {},
    data() {
        return {
            signingSessionData: {},
            hasSigned: false,
            success: false,
            showForm: true,
            error: null,
            saving: false,
            d2dId: null,
            iframelink: null
        };
    },
    mounted() {
        console.log(this.framelink);
        this.iframelink = this.framelink;
        window.addEventListener("message", (event) => {
            const type = event.data && event.data.type;
            const payload = event.data && event.data.payload;
            switch (type) {
                case "session_view.document.loaded":
                    console.log("Session view is loaded");
                    break;
                case "session_view.document.completed":
                    this.saveDocument(payload);
                    break;
                case "session_view.document.exception":
                    console.log("Exception during document finalization");
            }
        });
    },
    methods: {
        saveDealerInformation() {},
        saveDocument(data) {
            this.signingSessionData = data;
            this.hasSigned = true;
            this.iframelink = null;
            axios
                .post("/direct-to-dealer-onboarding-final-signature", {
                    key: this.documentkey,
                })
                .then((res) => {
                    this.success = true;
                })
                .catch((err) => {
                    this.error =
                        "Unable to finish contract signing, please contact the site administrator";
                });
        },
    },
};
</script>
<style scoped>
iframe,
.loadarea {
    width: 100%;
    height: 50em;
    background: #ececec;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: center;
}

.element-fadeinout {
    opacity: 0.8;
    animation: fade 1.5s infinite;
}

@keyframes fade {
    0%,
    100% {
        opacity: 0.4;
    }
    50% {
        opacity: 0.6;
    }
}
</style>
